import React from 'react';

import styles from './ShowWarningModal.module.scss';
import Modal from '../../modules/Modal';
import { ContainedButton } from '../../modules/Buttons';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { updateShowWarningModal } from '../../../store/sharedStore/sharedStoreSlice';
import { useHistory } from 'react-router-dom';
import { PATHS } from '../../../enums';

const ShowWarningModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const { showWarningModal, warningText, warningRedirect } = useAppSelector((state) => state.sharedStore);
  const history = useHistory();

  const handleClose = () => {
    if (warningRedirect) {
      history.push(PATHS.SHARED_WITH_ME.path);
    }
    dispatch(updateShowWarningModal({ show: false, warningText: '', redirect: false }));
  };

  return (
    <Modal open={showWarningModal}>
      <div className={styles.modalBody}>
        <div className={styles.modalTitle}>{warningText}</div>

        <div className={styles.actionBtns}>
          <ContainedButton className={styles.primaryButton} onClick={handleClose}>
            <span>Close</span>
          </ContainedButton>
        </div>
      </div>
    </Modal>
  );
};

export default ShowWarningModal;
